import React, { memo } from "react";
import Typography from "@mui/material/Typography";
import { theme as appTheme } from "../../../utils/theme";
import { Product, Size } from "../../../gobalType";
import ExplorerPromotionSlider from "./ExplorerPromotionSlider";

type ExplorerPromotionBlockProps = {
  products: Product[];
  catalogSizes: Size[];
};

const ExplorerPromotionBlock: React.FC<ExplorerPromotionBlockProps> = ({
  products,
  catalogSizes,
}) => (
  <>
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: 20,
        textAlign: "center",
        color: appTheme.palette.common.green,
        mb: 1,
      }}
    >
      Special Promotion - Limited Time Only!
    </Typography>
    <ExplorerPromotionSlider
      products={products}
      catalogSizes={catalogSizes}
    />
  </>
);

export default memo(ExplorerPromotionBlock);
